// import {
//   Box,
//   LinearProgress,
// } from '@mui/material';

import { memo } from "react";

const SplashScreen = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-center vh-100 bg-white fade show"
      aria-busy="true"
      aria-label="Loading"
    >
      <div className="text-center">
        <div
          className="spinner-border text-primary"
          role="status"
          style={{ width: "2rem", height: "2rem" }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>

        <div className="mt-3 text-muted fw-medium">Loading, please wait…</div>
      </div>
    </div>
  );
};

export default memo(SplashScreen);
// import React from 'react';
// // import {
// //   Box,
// //   LinearProgress,
// // } from '@mui/material';

// const SlashScreen = () => {

//   return (
//     <div className="page-loader">
//       <img src="/images/loader-bouncing-circles.svg" alt="" />
//     </div>
//   );
// }

// export default SlashScreen;
